import ScalarToggleSlider_vue_vue_type_script_setup_true_lang_default from "./ScalarToggleSlider.vue.script.js";
//#region src/components/ScalarToggle/ScalarToggleSlider.vue
var ScalarToggleSlider_default = ScalarToggleSlider_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarToggleSlider_default as default };

//# sourceMappingURL=ScalarToggleSlider.vue.js.map